<template>
    <div class="card-container">
        <common-top-form :model="formModel" :submitService="submitService" :submitData="submitData" @success="onSuccess"
                         :showDownloadPower="true" showDownloadPowerType="purple" downloadPowerText="合计"
                         downloadPower="/statistics/tatAssets" @down="down" :show="false">
            <select-organs v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId"></select-organs>
            <el-form-item label="用户手机">
                <el-input v-model="formModel.phoneNumber" maxlength="50" placeholder="请输入用户手机"></el-input>
            </el-form-item>
            <el-form-item label="奖励时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="memName" label="会员名称" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="memPhone" label="会员电话" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="selftAmount" label="奖励金额" min-width="130" show-overflow-tooltip :formatter="formatterTableNumber"></el-table-column>
            <el-table-column prop="parentName" label="上级姓名" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="parentPhone" label="上级电话" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="parentAmount" label="上级奖励金额" min-width="130" show-overflow-tooltip :formatter="formatterTableNumber"></el-table-column>
            <el-table-column prop="orderNo" label="订单号" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="createTime" label="奖励时间" min-width="130" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
        </common-table>
        <show-info-dialog title="合计" :show="true" ref="showInfoDialog" dialogWidth="400px" class="showInfoDialog">
            <div>
                <p>发放奖励数量：{{Number(dialogObj.totalNumber)}}个</p>
                <p>普通用户推荐数量：{{Number(dialogObj.generalNumber)}}个</p>
                <p>用户奖励金额：{{toDoubleThousands(dialogObj.memAwardAmount * 100 / 10000)}}元</p>
                <p>上级奖励金额：{{toDoubleThousands(dialogObj.parentAwardAmount * 100 / 10000)}}元</p>
                <p>合计奖励金额：{{toDoubleThousands(dialogObj.totalAwardAmount * 100 / 10000)}}元</p>
            </div>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import ShowInfoDialog from '../../dialog/ShowInfoDialog'

    import FinanceService from 'service/FinanceService'
    import OrganService from 'service/OrganService'
    import TimeRange from 'service/constant/TimeRange'
    import StatisticsService from 'service/StatisticsService'

    import AcctTypes from 'service/constant/AcctTypes'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "newawarddetail",
        components: {
            CommonTopForm, CommonTable, SelectOrgans, ShowInfoDialog
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    phoneNumber: '',
                    time: [],
                },
                tableData: [],
                page: {},
                params: {},
                submitService: FinanceService.tatGeneralizationDtlList,
                isPage: false,
                dialogObj:{}
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    userId: this.userId,
                    phoneNumber: this.formModel.phoneNumber.trim(),
                    simpleTatId: this.formModel.tatSimpleId,
                    startDate: this.formModel.time[0],
                    endDate: this.formModel.time[1],
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length == 0) {
                    delete this.params.startDate;
                    delete this.params.endDate;
                }

                return this.params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods: {
            down() {
                this.doLoad(FinanceService.tatGeneralizationDtlAwardSum,this.submitData,res => {
                    this.doCheck(res,res =>{
                        const result = res.contents;
                        this.dialogObj = result;
                        this.$nextTick(()=>{
                            this.$refs.showInfoDialog.open();
                        })
                    });
                },'信息获取失败')
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res)
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                    console.log('result', this.tableData)
                });
            },
        }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/NewAwardDetail.vue